import logo from '../logo.svg';
import { useState,useEffect } from "react";
import { useLocation as location2} from "wouter";
import Home from "../pages/home";
import Order from "../pages/order";
import FoodDetailModal from "../pages/foodDetailModal";
import Contact from "../pages/contact";
import { Link } from 'wouter';
import post from '../post';
import { Navbar,Page } from 'konsta/react';
import Alert from '../components/Alert';
import { VerCarrito } from '../components/Utilities';
import OrderStatus from '../components/OrderStatus'; 
import * as Constants from '../constants';
const cn = require('classnames');


function Main() {
  const [location, navigate] = location2();
  const [data,setData]=useState({});
  const [alert, setAlert] = useState({ isOpen: false, title: '', message: '' });
  const user_id = localStorage.getItem('token');
  const [orderDetailOpen, setOrderDetailOpen] = useState(0);
  if (!user_id) {
    navigate('/login');
  }

  useEffect(() => {
    const getData=async () => {
        const t=await post('getInitData',{},false);
        if(t.result){
            setData(t.data);
        }
      }
    getData();
  }
, []);
const [size, setSize] = useState('Default');
  const [currentPage,setCurrentPage]=useState('home')
  const [selectedItem,setSelectedItem]=useState(false);
  return (
    <>
    
    <div id="webcrumbs" > 
       <VerCarrito hasTabNav={true} />
      <Alert isOpen={alert.isOpen} title={alert.title} message={alert.message} onClose={() => setAlert({ isOpen: false, title: '', message: '' })} />
      <OrderStatus  isOpen={orderDetailOpen} onClose={() => setOrderDetailOpen(0)} />
            <Navbar
              title={Constants.BUSINESS_NAME}
              
              className="top-0 sticky"
              medium={size === 'Medium'}
              large={size === 'Large'}
              transparent={false}
              innerClassName='bg-primary-700'
              right={(<div className="flex items-center space-x-3">
                {/*<button className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors relative">
                    <span  className="material-symbols-outlined">notifications</span>
                    <div   className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
                    <span className="text-xs text-white font-bold">3</span>
                    </div>
                </button>*/}
                <Link href="/profile">
                    <button className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors">
                        <span className="material-symbols-outlined">person</span>
                    </button>
                </Link>
                </div>)}
            />
            <div className="  bg-neutral-50 relative  overflow-hiddens">
            
            
    {currentPage === 'home' && (
     <Home switchTab={setCurrentPage} data={data} setOrderDetailOpen={setOrderDetailOpen} />
   )}
   {currentPage === 'order' && (
    <Order 
        setSelectedItem={setSelectedItem}
        setCurrentPage={setCurrentPage}
        setAlert={setAlert}
    />
   )}
   {currentPage === 'contact' && (
    <Contact />
    )}

  <nav className="sticky bottom-0 left-0 right-0 bg-white border-t border-neutral-200 z-40 shadow-lg h-[81px]">
        <div className="flex justify-around items-center py-3">
          <button className={cn("flex flex-col items-center space-y-1 transition-colors",currentPage=='home'?'text-primary-600 hover:text-primary-700':'text-neutral-500 hover:text-neutral-700')}
          onClick={() => setCurrentPage('home')}
        >
            <span className="material-symbols-outlined text-2xl">home</span>
            <span className="text-xs font-medium">Inicio</span>
          </button>
          <button className={cn("flex flex-col items-center space-y-1 transition-colors",currentPage=='order'?'text-primary-600 hover:text-primary-700':'text-neutral-500 hover:text-neutral-700')}
          onClick={() => navigate('/order')}
        >
            <div className="relative">
              <span className="text-2xl material-symbols-outlined">shopping_bag</span>
               
            </div>
            <span className="text-xs font-medium">Ordenar</span>
          </button>
          <button className={cn("flex flex-col items-center space-y-1 transition-colors",currentPage=='contact'?'text-primary-600 hover:text-primary-700':'text-neutral-500 hover:text-neutral-700')}
          onClick={() => setCurrentPage('contact')}
        >
              <span className="text-2xl material-symbols-outlined">call</span>
             
            <span className="text-xs font-medium">Contacto</span>
          </button>
          {/*<button className={cn("flex flex-col items-center space-y-1 transition-colors",currentPage=='profile'?'text-primary-600 hover:text-primary-700':'text-neutral-500 hover:text-neutral-700')}
          onClick={() => setCurrentPage('profile')}
        >
            <span className="text-2xl material-symbols-outlined">call</span>
            <span className="text-xs font-medium">Perfil</span>
          </button>*/}
        </div>
      </nav>
    
       
     
    
    </div> 
    
        </div>
    </>
  );
}

export default Main;
